/* tslint:disable */
/* eslint-disable */
export enum ReassignBidderConflictType {
  AlreadyAssigned = 'already_assigned',
  TargetUserNotFound = 'target_user_not_found',
  TargetAlreadyHasPrimaryBidderForAuction = 'target_already_has_primary_bidder_for_auction'
}
